import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';
import Events from 'HSNDIR/Events.js';

import "LIBS/mailcheck.js";

// defines Events and Instance functions
import "HSNDIR/Application.js";


/**
* HSN
* The HSN namespace exists to contain all HSN-specific variables, objects,
* classes, functions and constants to prevent conflicts with other libraries
* that may be loaded.
**/
// ReSharper disable once InconsistentNaming
var HSN = window.HSN || {};

HSN.Language = HSN.Language || {};

var pageMask = '<div id="wait-mask" class="wait-mask"></div>';
var pageWait = '<div id="wait-mask" class="wait-mask"><div class="spinner-positioner"><div class="spinner-container"><div id="floatingCircles64"><div class="f_circle64" id="frotate64_01"></div><div class="f_circle64" id="frotate64_02"></div><div class="f_circle64" id="frotate64_03"></div><div class="f_circle64" id="frotate64_04"></div><div class="f_circle64" id="frotate64_05"></div><div class="f_circle64" id="frotate64_06"></div><div class="f_circle64" id="frotate64_07"></div><div class="f_circle64" id="frotate64_08"></div></div></div></div></div>';
var containerWait = '<div id="container-wait" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div>';


/**
    * HSN.Instance() -> HSN.Application | null
    * HSN.Instance(newInstance) -> HSN.Application
    * - newInstance (HSN.Application): The new HSN.Application instance to make available.
    *
    * Exposes a static singleton method that will return the current instance of
    * the [[HSN.Application]] that represents the page. Additionally if given an
    * argument it will replace the current instance with a new one. While this
    * is not an exact implementation of the Singleton Pattern, it is good enough
    * for use in Javascript.
    **/
/*
Usage:
    HSN.Instance(new HSN.Application(...));
    var hsnApplicationInstance = HSN.Instance();
*/
HSN.Instance = function (newInstance) {
    if (null != newInstance)
        HSN._instance = newInstance;
    return HSN._instance;
};

/**
    * HSN.ProxyButton(element[, cssClass]) -> null
    * - element (HTMLElement): The element that should be replaced with a stylized button.
    * - cssClass (String): The optional css class to add to the replacement button.
    *
    * Hides the element provided, such as an input button and replaces it with
    * another that proxies click events allowing for form submissions while providing more
    * robust styling opportunities.
    **/
HSN.ProxyButton = function (button, cssClass, isPreOrder = false) {
    button = $(button);
    if (button.data('HSN.ProxyButton.Processed'))
        return false;

    button.css({
        'position': 'absolute',
        'left': '-9999px'
    });
    var proxy = $('<span class="proxy-button">' + button.attr('value') + '</span>').on('click', function () {
        button.click();
    });
    if (isPreOrder) {
        proxy = $('<span class="proxy-button"><span class="topLine">PRE-ORDER NOW</span><span class="bottomLine">' + button.attr('value') + '</span></span>').on('click', function () {
            button.click();
        });
    }
    if (button.attr('id')) {
        proxy.attr('id', button.attr('id') + '-proxy');
    }
    if (cssClass) {
        proxy.addClass(cssClass);
    }
    if (button.attr('tabindex')) {
        proxy.attr('tabindex', button.attr('tabindex'));
    }
    if (button.data('tooltip')) {
        proxy.data('tooltip', button.data('tooltip'));
    }
    button.before(proxy);

    button.data('HSN.ProxyButton.Processed', true);

    return proxy;
};

//Import javascript dynamic module importer
//Only use for for places that don't have js es2015+ compiler, like cshtml views
HSN.DynamicImport = function (moduleName) {
    switch(moduleName) {
        case "Gap":
            var gapPromise = import(/* webpackChunkName: "Gap" */ 'MOBILE/Gap.js');
            return gapPromise.then(gap => gap.default);
    }
    return Promise.reject();
}

HSN.AsyncLoad = function (url, callback, id) {
    var doc = document;
    if (id && doc.getElementById(id)) {
        return;
    }

    var tagName = 'script';
    var newScriptElement = doc.createElement(tagName);
    newScriptElement.async = true;
    newScriptElement.id = id;
    newScriptElement.src = url;

    if (callback) {
        if (newScriptElement.addEventListener) {
            newScriptElement.addEventListener('load', function () {
                callback();
            }, false);
        }
        else {
            newScriptElement.onreadystatechange = function () { // old IEs
                if (newScriptElement.readyState in { loaded: 1, complete: 1 }) {
                    newScriptElement.onreadystatechange = null;
                    callback();
                }
            };
        }
    }

    var firstScriptElement = doc.getElementsByTagName(tagName)[0];
    firstScriptElement.parentNode.insertBefore(newScriptElement, firstScriptElement);
};

// TODO: If calling the callback every time AsyncLoad is called is okay, then this function can be removed.
HSN.EnsureAsyncLoaded = function (url, callback, id) {
    if (id && document.getElementById(id)) {
        callback();
    } else {
        HSN.AsyncLoad(url, callback, id);
    }
}

/**
    * HSN.ValidateEmail(emailAddress) -> null
    * - emailAddress (String): The email address to validate.
    *
    * Returns true if valid, otherwise false.
    * 
    * regex's suck for this
    * https://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    **/
HSN.ValidateEmail = function (emailAddress) {
    var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return filter.test(emailAddress);
};

/**
    * HSN.Tooltip(element) -> null
    * - element (HTMLElement|jQuery|String): The element, jQuery object, or CSS Selector that should be given a tooltip.
    * - classname (String): Optional class name applied to the tooltip.
    *
    * Provides for a stylized tooltip display read from the data-tooltip
    * attribute of the provided element(s) when hovered.
    **/
HSN.Tooltip = function (element, classname) {
    if (!HSN.Tooltip.__flywheel) {
        HSN.Tooltip.__flywheel = $('<div class="tooltip" role="tooltip" id="tooltip" aria-hidden="true"><span class="text"></span><span class="arrow"></span></div>');
        if (classname) {
            HSN.Tooltip.__flywheel.addClass(classname);
        }
        HSN.Tooltip.__flywheel
            .on('mouseenter', function () {
                this.__dontClose = true;
            })
            .on('mouseleave', function () {
                this.__dontClose = false;
            });
        $('body').append(HSN.Tooltip.__flywheel);
    }

    var elements = $(element);
    elements.each(function () {
        if (Modernizr.touchevents && ($(this).hasClass('favorite') || $(this).hasClass('express-buy-proxy'))) {
            return true;//ignore touch tooltips for certain types
        }

        var configureToolTip = function (eventScope) {
            var trigger = $(eventScope);

            if($(eventScope).data('tooltip') === "")
                return;

            var offset = trigger.offset().top;
            if($(eventScope).parents('.lessman').length || $(eventScope).parents('.lessman-carousel-product-card').length || $(eventScope).parents('.lessman-torso').length) {
                offset = offset - 120;
            }

            /* Unfortunately since we have to use CSS3Pie for rounded-corners in IE7/8,
            * we must update the tooltip in advance of the timeout or the animation will
            * be jaring.
            */
            HSN.Tooltip.__flywheel.find('.text').html($(eventScope).data('tooltip'));
            HSN.Tooltip.__flywheel
                // Just in case we need to position the tooltip relative to the mouse position at some point in the future.
                //.css({'top': (e.pageY - HSN.Tooltip.__flywheel.outerHeight() - 20), 'left': (e.pageX - (HSN.Tooltip.__flywheel.outerWidth() / 2))})
                .css
                ({
                    'top' : (offset - HSN.Tooltip.__flywheel.outerHeight() - 5),
                    'left' : (trigger.offset().left - (HSN.Tooltip.__flywheel.outerWidth() / 2) + (trigger.outerWidth() / 2))
                })
                // We also have to do this to force CSS3Pie to re-position it's canvas element to match the new position of the actual element. :(
                .removeClass('tooltip').addClass('tooltip');
        };

        var onMouseEnter = function () {
            var scope = this;

            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if(timeout)
                clearTimeout(timeout);

            configureToolTip(scope);

            HSN.Tooltip.__flywheel.data('timeout', setTimeout
                (
                    function () {
                        HSN.Tooltip.__flywheel.show();
                        HSN.Tooltip.__flywheel.attr('aria-hidden', 'false');
                    },
                    500
                ));
        };

        var onMouseLeave = function () {
            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if(timeout) {
                clearTimeout(timeout);
            }

            HSN.Tooltip.__flywheel.data('timeout', setTimeout
                (
                    function () {
                        if(!HSN.Tooltip.__flywheel.__dontClose) {
                            HSN.Tooltip.__flywheel.hide();
                            HSN.Tooltip.__flywheel.attr('aria-hidden', 'true');
                        }
                    },
                    250
                ));
        };

        var onFocus = function () {
            var scope = this;

            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout)
                clearTimeout(timeout);

            configureToolTip(scope);

            HSN.Tooltip.__flywheel.data('timeout', setTimeout
                (
                    function () {
                        HSN.Tooltip.__flywheel.show();
                        HSN.Tooltip.__flywheel.attr('aria-hidden', 'false');
                    },
                    500
                ));
        }

        var offFocus = function () {
            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout) {
                clearTimeout(timeout);
            }

            HSN.Tooltip.__flywheel.data('timeout', setTimeout
                (
                    function () {
                        if (!HSN.Tooltip.__flywheel.__dontClose) {
                            HSN.Tooltip.__flywheel.hide();
                            HSN.Tooltip.__flywheel.attr('aria-hidden', 'true');
                        }
                    },
                    250
                ));
        }

        var showOnClickOrKey = function (eventScope) {
            configureToolTip(eventScope);

            if(HSN.Tooltip.__flywheel.css('display') === 'none') {
                HSN.Tooltip.__flywheel.__dontClose = true;
                HSN.Tooltip.__flywheel.show();
            }
            else {
                HSN.Tooltip.__flywheel.__dontClose = false;
                HSN.Tooltip.__flywheel.fadeOut();
            }
        };

        $(this)
            .on('mouseenter', onMouseEnter)
            .on('mouseleave', onMouseLeave)
            .on('focusin', onFocus)
            .on('focusout', offFocus)
            .on('click', function (e) {
                e.preventDefault();
                showOnClickOrKey(this);
            })
            .on('keyup', function (e) {
                e.preventDefault();

                if(e.keyCode === 13) {
                    showOnClickOrKey(this);
                }
            });
        return true;
    });
};

/**
    * HSN.AnimateAccordion(container, toggleindex, config) -> null
    * - container (jQuery selector): The selector that should be animated.
    * - toggleindex (int): The number of the toggleContainer to be animated.
    * - showBottomDotted (bool): for tight accordions where a dotted-line class should be added at the bottom of the container.
    * - scrollToTop (bool): if you want the page to scroll to the top when animation is done.
    * - config (object): Contains two possible functions to be executed either during fadeIn or fadeOut.
    *
    * Provides for a nice animated accordion display
    **/
HSN.AnimateAccordion = function (container, toggleindex, showBottomDotted, scrollToTop, config) {
    config = (config || {});
    var scrollOffset = config.scrollOffset || 0;
    $("." + container + "[toggleindex!='" + toggleindex + "']").each(function () {
        if (showBottomDotted) $(this).prev().addClass("bottom-dotted-lines");
        $(this).hide();
    });

    var toggleContainer = $("." + container + "[toggleindex='" + toggleindex + "']");
    var hasPeek = toggleContainer.hasClass('has-peek');
    var hadPeek = toggleContainer.hasClass('had-peek');

    if (toggleContainer.is(":visible") && !hasPeek) {
        if (config.beforeFadeOut) {
            config.beforeFadeOut();
        }
        toggleContainer.fadeOut({
            duration: 500,
            queue: false,
            complete: function () {
                var prevContainer = toggleContainer.prev();
                if (showBottomDotted) {
                    prevContainer.addClass("bottom-dotted-lines");
                }
                if (config.fadeOutCallback) {
                    config.fadeOutCallback();
                }
                if (hadPeek) {
                    toggleContainer.removeClass('had-peek');
                    toggleContainer.addClass('has-peek');
                }
            }
        }).slideUp(500);
    }
    else {
        if (config.beforeFadeIn) {
            config.beforeFadeIn();
        }
        toggleContainer.fadeIn({
            duration: 500,
            queue: false,
            complete: function () {
                var prevContainer = toggleContainer.prev();
                if (showBottomDotted) {
                    prevContainer.removeClass("bottom-dotted-lines");
                }
                if (config.fadeInCallback) {
                    config.fadeInCallback();
                }
                if (scrollToTop) $('html,body').animate({ scrollTop: toggleContainer.parent().offset().top - scrollOffset }, 'slow');
                if (hasPeek) {
                    toggleContainer.removeClass('has-peek');
                    toggleContainer.addClass('had-peek');
                }
            }
        }).css('display', 'none').slideDown(500);
    }
};

/**
    * HSN.AddErrortreatment(formSelector, data) -> null
    * - formSelector (jQuery selector): The selector of the form to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    *      - data.errorFields contains the Key matching the input page element with a value of the first error message associated to that key.
    *      - data.errors contains the flattened collection of all error messages for all keys.
    * Will add standardized error treatments to the top of a given form.
    **/
HSN.AddErrorTreatment = function (formSelector, data) {
    var $errors = $('<div class="errors" tabindex="-1"><div class="errors-top"><span tabindex="0"><b>OOPS.</b> Please fix the following:</span></div><ul></ul></div>');
    var form = $(formSelector);
    $('.errors', form.parent()).remove();
    $('.input-validation-error', formSelector).removeClass("input-validation-error");
    $('.field-validation-error', formSelector).removeClass("field-validation-error");

    var errorFieldsLength = data.errorFields.length;
    for (var i = 0; i < errorFieldsLength; i++) {
        if(data.errorFields[i].Value) {
            $errors.find('ul').append('<li>' + data.errorFields[i].Value + '</li>');
        }
        $('[name="' + data.errorFields[i].Key + '"]', formSelector).each(function (index, domEle) {
            $(domEle).addClass("input-validation-error");
        });
        $('label[for="' + data.errorFields[i].Key + '"]', formSelector).each(function (index, domEle) {
            $(domEle).addClass("field-validation-error");
        });
    }
    if(data.errorFieldIds) {
        var errorFieldIdsLength = data.errorFieldIds.length;
        for (var x = 0; x < errorFieldIdsLength; x++) {
            if(data.errorFieldIds[x].Value) {
                $errors.find('ul').append('<li>' + data.errorFieldIds[x].Value + '</li>');
            }
            $('#' + data.errorFieldIds[x].Key, formSelector).each(function(index, domEle) {
                $(domEle).addClass("input-validation-error");
            });
            $('label[for="' + data.errorFieldIds[x].Key + '"]', formSelector).each(function(index, domEle) {
                $(domEle).addClass("field-validation-error");
            });
        }
    }

    if (typeof data.errors != 'undefined') {
        $('li', $errors).remove();
        var errorsLength = data.errors.length;
        for (var j = 0; j < errorsLength; j++) {
            $errors.find('ul').append('<li><span tabindex="0">' + data.errors[j] + '</span></li>');
        }
    }

    $('div.errors', formSelector).remove();
    $(formSelector).before($errors);
    $errors.find('.errors-top *[tabindex=0]').first().focus();
};
HSN.ClearFormErrors = function(selector) {
    $('.errors', $(selector).parent()).remove();
    $('.input-validation-error', selector).removeClass("input-validation-error");
    $('.field-validation-error', selector).removeClass("field-validation-error");
}
/**
    * HSN.HandleCheckoutError(containerName, data, alertMessage) -> null
    * - containerName (jQuery selector): The selector of the container to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    * - alertMessage (string) : message to alert on.
    * This function is mainly called after an ajax functions data.success = false.
    There could be multiple scenarious why this happened.
    Data.signIn = true - customers session is not authenticated. Send to signin.
    Data.error has content - likely an API error, or some other misc error, put this into the containers error section.
    Data.alertError has content - We want to display an alert to the customer with this content.
    As a default, alert the alertMessage that was passed in.
    **/
HSN.CheckoutHandleError = function (containerName, data, alertMessage) {
    if (data.signIn) {
        if (data.signIn === 'modal') {
            HSN.Instance().GetSignInModal().Show(true, false);
        }
        else if (data.signIn === 'gap') {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            gap.ExecCommand(command);
        }
        else {
            window.location = '/checkout/signin';
        }
        HSN.RemoveWait();
    } else {
        HSN.RemoveWait();
        if (data.error) {
            var errorContainer = $(containerName).find('.error-container')[0];
            $(errorContainer).html(data.error);
            $(errorContainer).toggle(true);
            HSN.ScrollToElement($(errorContainer));
        } else if (data.alertError) {
            alert(data.alertError);
        } else {
            alert(alertMessage);
        }
    }
};

/**
    * HSN.HandleAjaxError(containerName, data, alertMessage) -> null
    * - containerName (jQuery selector): The selector of the container to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    * - alertMessage (string) : message to alert on.
    * This function is mainly called after an ajax functions data.success = false.
    There could be multiple scenarious why this happened.
    Data.signIn = true - customers session is not authenticated. Send to signin.
    Data.error has content - likely an API error, or some other misc error, put this into the containers error section.
    Data.alertError has content - We want to display an alert to the customer with this content.
    As a default, alert the alertMessage that was passed in.
    **/
HSN.HandleAjaxError = function (containerName, data, alertMessage) {
    if (data.signIn) {
        if (data.signIn === 'modal') {
            HSN.Instance().GetSignInModal().Show(true, false);
        }
        else if (data.signIn === 'gap') {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            gap.ExecCommand(command);
        }
        else {
            window.location = '/signin';
        }
        HSN.RemoveWait();
    } else {
        HSN.RemoveWait();
        if (data.error) {
            var errorContainer = $(containerName).find('.error-container')[0];
            $(errorContainer).html(data.error);
            $(errorContainer).toggle(true);
            HSN.ScrollToElement($(errorContainer));
        } else if (data.alertError) {
            alert(data.alertError);
        } else {
            alert(alertMessage);
        }
    }
};

/**
    * HSN.FormatPhone(fieldSelector) -> null
    * - fieldSelector (jQuery selector): The selector of the field to add formatting to.
    *
    * Will add standardized phone formatting to a given field.
    **/
HSN.FormatPhone = function (fieldSelector) {

    function format() {
        var input = $(this);
        var digits = input.val().replace(/[^\d]/g, '');

        if (digits.length < 3) {
            return null;
        }
        var prefix;
        var rest;
        if ((digits.length >= 3 && digits.length <= 6)) {
            prefix = digits.substring(0, 3);
            rest = digits.substring(3, digits.length);
            return input.val(prefix + '-' + rest);
        }

        if (digits.length > 6 && digits.length <= 10) {
            var areaCode = digits.substring(0, 3);
            prefix = digits.substring(3, 6);
            rest = digits.substring(6, digits.length);
            return input.val('(' + areaCode + ')' + prefix + '-' + rest);
        }

        return null;
    }

    $.fn.formatsPhone = function () {
        this.on('keypress', format);
        this.on('blur', format);
        this.attr('maxlength', '13');
    };

    $(fieldSelector).formatsPhone();
};

/**
    * HSN.FormatCurrency =function(value, precision) -> null
    * - value (Number value): The value to convert to a currency string.
    * - precision (Number precision): How many decimal places.
    *
    * Will format a given javascript decimal to a currency string.
    **/
HSN.FormatCurrency =function(value, precision) {
    var re = '\\d(?=(\\d{' + (3) + '})+' + (precision > 0 ? '\\.' : '$') + ')';
    return '$' + value.toFixed(Math.max(0, ~~precision)).replace(new RegExp(re, 'g'), '$&,');
},

/**
* HSN.ShowProgressBar(fieldSelector) -> null
* - fieldSelector (jQuery selector): The selector of the input to check the email domain.
*
* Will show password strength progress bar.
**/
HSN.ShowProgressBar = function (fieldSelector) {
    $(document).on('keyup', fieldSelector, function () {
        // Must have capital letter, numbers and lowercase letters
        var strongRegex = new RegExp('^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$', 'g');

        // Must have either capitals and lowercase letters or lowercase and numbers
        var mediumRegex = new RegExp('^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$', 'g');

        if (strongRegex.test($(this).val())) {
            $('#strength').html('Strong');
            $('#weak-strength').removeClass().addClass('strong-strength');
            $('#medium-strength').removeClass().addClass('strong-strength');
            $('#strong-strength').removeClass().addClass('strong-strength');
        }
        else if (mediumRegex.test($(this).val())) {
            $('#strength').html('Medium');
            $('#weak-strength').removeClass().addClass('medium-strength');
            $('#medium-strength').removeClass().addClass('medium-strength');
            $('#strong-strength').removeClass();
        }
        else {
            $('#strength').html('Weak');
            $('#weak-strength').removeClass().addClass('weak-strength');
            $('#medium-strength').removeClass();
            $('#strong-strength').removeClass();
        }
        return true;
    });
}

/**
* HSN.SuggestEmail(fieldSelector) -> null
* - fieldSelector (jQuery selector): The selector of the input to check the email domain.
*
* Will add standardized email domain.
**/
HSN.SuggestEmail = function (fieldSelector) {

    function suggest() {

        var $hint = $("#hint");
        if (fieldSelector === "#template-product-detail-brand-signup-email")
            $hint = $("#hint-brand");

        $hint.css('display', 'none');
        $(this).mailcheck({
            suggested: function (element, suggestion) {
                if (!$hint.html()) {
                    suggestion = "Did you mean " + suggestion.address +  "&#64;" + suggestion.domain + "?";
                    $hint.html(suggestion).fadeIn(150);
                }
                else {
                    $(".address").html(suggestion.address);
                    $(".domain").html(suggestion.domain);
                }
            },
            empty: function () {
            }
        });


        $hint.on('click', '.domain', function () {
            $(fieldSelector).val($(".suggestion").text());
            $hint.fadeOut(200, function () {
                $(this).empty();
            });
            return false;
        });


    }

    $.fn.suggestEmail = function () {
        this.on('blur', suggest);
    };

    $(fieldSelector).suggestEmail();
};
/**
* HSN.ConstrainSelectElements (selector, container) -> null
* - fieldSelector (jQuery selector): The selector of the select elements to constrain.
*
**/
HSN.ConstrainSelectElements = function (selector, container) {
    var usedTypes = [];
    var notSeletedSelector = selector + ' option:not(:selected)';
    var selectedSelector = selector + ' option:selected';
    var optionsNotSelected = $(notSeletedSelector, container);
    var optionsSelected = $(selectedSelector, container);

    optionsNotSelected.prop('disabled', false);
    optionsNotSelected.show();

    //Get all the types that are currently selected
    optionsSelected.each(function () {
        if($(this).val() !== 'Select') {
            usedTypes.push({ Type : $(this).val() });
        }
    });

    //Unique-ify!
    usedTypes = $.uniqueSort(usedTypes);

    //Hide from lists if already selected
    optionsNotSelected.each(function () {
        var thisValue = $(this).val();
        var opt = $(this);
        $.each(usedTypes, function () {
            if (thisValue === this.Type) {
                opt.prop('disabled', true);
                opt.hide();
            }
        });
    });
};
/**
    * HSN.ResetForm(fieldSelector) -> null
    * - form (jQuery selector/object): The form to reset.
    *
    * This will clear all form fields and remove error formatting.
    **/
HSN.ResetForm = function (form) {
    $(':input', form)
        .not(':button, :submit, :reset')
        .not('input[type="hidden"]')
        .not('select')
        .val('')
        .prop('checked', false)
        .prop('selected', false)
        .prop('disabled', false);
    $('select', form)
        .val('0')
        .prop('selected', false);
    $('div.errors').remove();
};
/**
    * HSN.PlusMinus(fieldSelector) -> null
    * - selector (jQuery selector/object): The element to switch.
    *
    * This will clear all form fields and remove error formatting.
    **/
HSN.PlusMinus = function (selector) {
    var element = $(selector);
    if (element.hasClass('plus')) {
        element.removeClass('plus');
        element.addClass('minus');
    }
    else {
        element.removeClass('minus');
        element.addClass('plus');
    }
};

HSN.OnHomePage = function() {
    if (window.location.pathname === '/') {
        //-----do stuff to homepage-----      
    }
};

// Loader Animation
// Utilizes existing #wait-mask
HSN.LoaderGet = function(width, useWaitMask) {
    if (!width) {
        width = 400;
    }

    var fontSize = 1 * (parseFloat(width) / 400.0);
    var waitMask = $('<div id="wait-mask" class="wait-mask" />');
    var loadingContainer = $('<div class="animated-loader" />')
        .css({ width: width, height: width, fontSize: fontSize });

    //clean, almost path free svg - don't muck it up!
    const animationElements =
        $(`<div class="loading-animation default">
            <svg class="logo" viewBox="0 0 380 230">
                <title id="loading-animation-title">HSN Loading, Please Wait...</title>
                <desc id="loading-animation-desc">Shaped as a blue circle, the HSN logo is spinning as the process is loading.</desc>
                <circle fill="#2482c9" r="74" cy="91" cx="189"></circle>
                <g transform="translate(-53,16)
                              scale(1.5)">
                    <path d="m146.568335,62.253923l0,-23.673697l-0.484883,0l-4.082684,0l0,9.07509l-13.778626,0l0,-9.07509l-4.558364,0l0,23.673697l4.558364,0l0,-10.0513l13.778626,0l0,10.0513l4.567567,0z" id="logo-h"></path>
                    <path d="m172.295685,55.495989c0.372147,-6.744999 -7.572349,-7.54 -11.809758,-7.882284c-4.4393,-0.353266 -6.250567,-1.120811 -6.087789,-2.962187c0.177733,-2.025025 3.644391,-2.917037 6.101018,-2.784028c3.141676,0.167176 5.199699,0.439294 8.613439,2.83711c0,0 1.150951,-1.585731 2.375526,-3.16292c-4.200597,-3.323384 -8.503003,-3.693124 -11.020025,-3.740714c-1.872237,-0.025015 -10.522488,0.345334 -10.611642,7.156228c-0.088579,6.225168 7.748356,6.898142 10.579431,7.292897c2.077004,0.28127 7.242191,0.41733 7.242191,2.939612c0,2.330701 -4.158033,3.356941 -7.170868,3.142785c-4.580797,-0.3252 -6.36618,-1.882865 -8.636447,-4.313627c-1.162455,1.30202 -2.869037,3.125702 -2.869037,3.125702c2.561887,3.103737 7.094943,5.510094 11.434161,5.685812c2.480785,0.097621 11.49513,-0.489325 11.8598,-7.334386" id="logo-s"></path>
                    <path d="m194.189293,62.168139l3.943488,0l0,-23.54618l-0.47453,0l-4.048173,0l0,15.752975c-1.476507,-1.738874 -13.430063,-15.752975 -13.430063,-15.752975l-4.979402,0l0,23.54618l4.428947,0l0,-17.222171c1.494338,1.771821 14.559732,17.222171 14.559732,17.222171" id="logo-n"></path>
                </g>
            </svg>

            <svg class="spinner" viewBox="0 0 66 66">
                <defs>
                    <linearGradient id="gradient-loader">
                        <stop offset="0%" stop-color="#7ccac6" stop-opacity="1"/>
                        <stop offset="100%" stop-color="#2c526c" stop-opacity="0"/>
                    </linearGradient>
                </defs>
                <circle class="path" fill="transparent" stroke-width="3" cx="33" cy="33" r="30" stroke="url(#gradient-loader)"></circle>
            </svg>
            <div class="textBlurb">Loading, please wait...</div>
        </div>`);

    loadingContainer.append(animationElements);
    if (useWaitMask) {
        waitMask.append(loadingContainer);
        return waitMask;
    }
    else {
        return loadingContainer;
    }
}

HSN.LoaderSetWait = function (text, autoCloseTime) {
    if ($('#wait-mask .animated-loader').length === 0) {
        var d = $(document);
        $('body').prepend(HSN.LoaderGet(300, true));
        $('#wait-mask').css({ width : d.width(), height : d.height() });
        HSN.LoaderReposition();
    }
    if (text) {
        $('.animated-loader .textBlurb').html(text);
    }

    if (autoCloseTime) {
        window.setTimeout(HSN.RemoveWait, autoCloseTime);
    }
};

HSN.LoaderReposition = function() {
    var w = $(window);
    var container = $('#wait-mask .animated-loader');

    var top = ((w.height() - container.height()) / 2) + w.scrollTop();
    var left = (w.width() - container.width()) / 2;

    container.css({ top: top, left: left });
};

/**
    * HSN.GetHsnArcadeObjectName() -> null
    * 
    * Gets the HsnArcadeObjectName if present.
    **/
HSN.GetHsnArcadeObjectName = function() {
    return window.HsnArcadeObjectName || null;
};

/**
* HSN.SetPageMask() -> null
*
* Places page wait mask (with no visual spinner) over entire page.
**/
HSN.SetPageMask = function () {
    if ($('#wait-mask').length === 0) {
        $('#torso').prepend(pageMask);
        $('#wait-mask').css('height', $(document).height());
        $('#wait-mask').css('width', $(document).width());
    }
};
/**
* HSN.RemovePageMask() -> null
*
* Removes page wait mask.
**/
HSN.RemovePageMask = function () {
    $('#wait-mask').remove();
};
/**
* HSN.SetWait() -> null
*
* Places page wait mask (with visual spinner) over entire page.
**/
HSN.SetWait = function (waitText) {
    if ($('#wait-mask .spinner-container, #wait-mask .animated-loader').length === 0) {
        $('body').prepend(pageWait);
        $('#wait-mask').css('height', $(document).height());
        $('#wait-mask').css('width', $(document).width());
        HSN.PositionSpinner();
    }
    if (waitText) {
        $('.spinner-container').prepend(waitText);
    }
};
/**
* HSN.SetTempWait() -> null
*
* Places page wait mask (with visual spinner) over entire page automatically removes after 3 seconds.
**/
HSN.SetTempWait = function (howLong) {
    $('body').prepend(pageWait);
    $('#wait-mask').css('height', $(document).height());
    $('#wait-mask').css('width', $(document).width());
    HSN.PositionSpinner();
    window.setTimeout(HSN.RemoveWait, howLong);
};

/**
* HSN.PositionSpinner() -> null
*
* Positions the spinner on the page.
**/
HSN.PositionSpinner = function () {
    var spinnerWidth = $('#wait-mask .spinner-positioner').width();
    var spinnerHeight = $('#wait-mask .spinner-positioner').height();
    var top = (($(window).height() - spinnerHeight) / 2) + $(window).scrollTop();
    $('#wait-mask .spinner-positioner').css('top', top);
    $('#wait-mask .spinner-positioner').css('left', ($(window).width() - spinnerWidth) / 2);
}
/**
* HSN.RemoveWait() -> null
*
* Removes page wait mask (with visual spinner) over entire page.
**/
HSN.RemoveWait = function () {
    $('#wait-mask').remove();
};
/**
* HSN.SetContainerWait(selector) -> null
* -selector (jQuery selector): The selector of the field to append the spinner css
* Adds a spinner below a container.
**/
HSN.SetContainerWait = function(selector, doPrepend) {
    if (doPrepend) {
        $(selector).prepend(containerWait);
    }
    else {
        $(selector).after(containerWait);
    }
};
/**
* HSN.RemoveContainerWait() -> null
* Removes the container spinner for all loaders.
**/
HSN.RemoveContainerWait = function () {
    $('#container-wait, .animated-loader').remove();
};
/**
* HSN.AddButtonProcessing(selector) -> null
* -selector (jQuery selector): The selector of the input button to mark as "processing"
* Marks classes to make button show as processing.
**/
HSN.AddButtonProcessing = function (selector) {
    $(selector).addClass('processing');
};
/**
* HSN.IsButtonProcessing(selector) -> bool
* -selector (jQuery selector): The selector of the input button to check is "processing"
* Checks if a button is processing.
**/
HSN.IsButtonProcessing = function (selector) {
    if ($(selector).hasClass('processing')) {
        return true;
    }
    return false;
};
/**
* HSN.ClearButtonProcessing(selector) -> null
* -selector (jQuery selector): The selector of the input button to clear "processing"
* Clears classes to mark if a button is processing.
**/
HSN.ClearButtonProcessing = function (selector) {
    if ($(selector).hasClass('processing')) {
        $(selector).removeClass('processing');
    }
};
/**
* HSN.GetMobileHeaderOffset() -> null
* Returns the height of the mobile header for offset scenarios.
**/
HSN.GetMobileHeaderOffset = function () {
    var offset = 0;

    var mobileUtilityNavV3 = $('#utility-nav-parent-v3 #utility-nav-v3');

    if(mobileUtilityNavV3.length) {
        offset += mobileUtilityNavV3.outerHeight();

        if(!mobileUtilityNavV3.is('.fixed')) {
            var subNavV3 = $('#utility-nav-parent-v3 #subnav-v3');

            if (subNavV3.length)
                offset += subNavV3.outerHeight();
        }
    }
    else {
        var subNav = $('#utility-nav-parent #subnav');
        var utilityNav = $('#utility-nav-parent #utility-nav');
        var search = $('#utility-nav-parent #search');

        if(subNav.length)
            offset += subNav.outerHeight();
        if(utilityNav.length)
            offset += utilityNav.outerHeight();
        if(search.length)
            offset += search.outerHeight();
    }

    return (offset);
};
/**
* HSN.GetDesktopStickyHeaderOffset() -> null
* Returns the height of the desktop sticky header for offset scenarios.
**/
HSN.GetDesktopStickyHeaderOffset = function () {
    var headerHeight = $('#primary-navigation').length > 0 ? $('#primary-navigation').outerHeight() : 0;
    if(headerHeight === 0) {
        return 0;
    }
    var stickyHeaderHeight = $('#primary-navigation .sticky-navigation').length > 0  && $('#primary-navigation .sticky-navigation').is(':visible') ? $('#primary-navigation .sticky-navigation').outerHeight() : 64;
    return (headerHeight - stickyHeaderHeight);
};
/**
* HSN.GetDesktopStickyHeaderOffset() -> null
* Returns the height of the desktop sticky header for offset scenarios.
**/
HSN.GetDesktopStickyHeaderHeight = function () {
    var stickyHeaderHeight = $('#primary-navigation .sticky-navigation').length > 0 && $('#primary-navigation .sticky-navigation').is(':visible') ? $('#primary-navigation .sticky-navigation').outerHeight() : 64;
    return stickyHeaderHeight;
};
/**
* HSN.ScrollToElement() -> null
* Scroll the page to a specific element.
**/
HSN.ScrollToElement = function (element, speed, padding) {
    var offset = 0;
    speed = speed || 'slow';
    padding = padding || 0;
    if(HSN.Instance().DeviceInformation.IsMobile) {
        offset = HSN.GetMobileHeaderOffset();
    }
    else {
        offset = HSN.GetDesktopStickyHeaderOffset();
    }
    $('html,body').animate({ scrollTop: element.offset().top - offset - padding }, speed);
};
/**
* HSN.EqualHeights(firstContainer, secondContainer) -> null
* -firstContainer (jQuery selector): The selector of the first container to match heights
* -secondContainer (jQuery selector): The selector of the second container to match heights
* -heightType (string): What type of height to set (height, min-height, max-height, etc)
* Will adjust the heights of the two containers, if the first container is taller than second, will set second container to height of first.
**/
HSN.EqualHeights = function (firstContainer, secondContainer, heightType) {
    var height1 = $(firstContainer).outerHeight();
    var height2 = $(secondContainer).outerHeight();
    var property = {};
    if (height1 > height2) {
        property[heightType] = height1;
        $(secondContainer).css(property);
    } else {
        property[heightType] = height2;
        $(firstContainer).css(property);
    }
}
/**
* HSN.EqualHeights(selector, triggerContinuously) -> null
* -container (jQuery selector): The selector that marks the container of the collection
* -selector (jQuery selector): The selector of the grid cells
* -triggerContinuously (boolean): True - binds function to window resize event.  False - only runs when method called.
* Will adjust the height of all elements with the supplied selector to the talleset member of the collection.
**/
HSN.SetCollectionEqualHeight = function (container, selector, triggerContinuously) {
    var elements = $(selector, container);
    elements.css("height", "auto");
    var max = Number.NEGATIVE_INFINITY;

    $.each(elements, function (index, item) {
        if ($(item).height() > max) {
            max = $(item).outerHeight();
        }
    });

    $(selector, container).css("height", max + "px");

    if (triggerContinuously) {
        $(window).resize(function () {
            HSN.SetCollectionEqualHeight(container, selector, false);
        });
    }
};
/**
* HSN.IncreaseBagIconCount(value) -> null
* -value (integer): - value to increase bag icon count by
* Will update the bag icon count to the increased value.
**/
HSN.IncreaseBagIconCount = function (value) {
    var bagIcons = $('.bag-item-count');
    var quantity = parseInt(value) || 0;
    if (bagIcons.length) {
        var itemsCount = (parseInt(bagIcons.html().replace(/[^\d]/g, '')) || 0) + quantity;
        bagIcons.html(itemsCount);
        bagIcons.attr('aria-label', 'My Bag, ' + itemsCount + ' items');
    }
}
/**
* HSN.SetBagIconCount(value) -> null
* -value (integer): - value to set bag icon count to
* Will update the bag icon count to the value.
**/
HSN.SetBagIconCount = function (value) {
    var bagIcons = $('.bag-item-count');
    bagIcons.html(parseInt(value));
    bagIcons.attr('aria-label', 'My Bag, ' + value + ' items');
}
/**
* HSN.GetBagIconCount() -> null
* Will return the bag icon count.
**/
HSN.GetBagIconCount = function () {
    var bagIcon = $('.bag-item-count').first();
    return parseInt(bagIcon.html().replace(/[^\d]/g, '')) || 0;
}
/**
* HSN.OnCoremetricsLoad(function) -> null
* -callback (callback): Function to call when the coremetrics js is loaded
**/
HSN.OnCoremetricsLoad = function (callback) {
    if (typeof (window.cG7) != 'undefined') {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.CM_LOADED, function () {
            callback();
        });
    }
}
/**
* HSN.OnGoogleAnalyticsLoad(function) -> null
* -callback (callback): Function to call when the google analytics js is loaded
**/
HSN.OnGoogleAnalyticsLoad = function (callback) {
    if (window.ga) {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.GOOGANALYTICS_LOADED, function () {
            callback();
        });
    }
}

HSN.OnGtmLoad = function (callback) {
    if (window.google_tag_manager) {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.GTM_LOADED, function () {
            callback();
        });
    }
}

HSN.OnAccountStatusLoad = function (callback) {
    var accountStatusData = HSN.Instance().GetAccountStatusData();
    if (accountStatusData) {
        callback(accountStatusData);
    } else {
        HSN.Instance().Events.On(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_COMPLETE, function (data) {
            callback(data);
        });
    }
}

HSN.OnAccountStatusDetailLoad = function (callback) {
    var accountStatusDetailData = HSN.Instance().GetAccountStatusDetailData();
    if (accountStatusDetailData) {
        callback(accountStatusDetailData);
    } else {
        HSN.Instance().Events.On(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_DETAIL_COMPLETE, function (data) {
            callback(data);
        });
    }
}

HSN.OnAdobeTargetLoad = function (callback) {
    if (HSN.AdobeTarget && HSN.AdobeTarget.IsLoaded()) {
        callback();
    } else {
        HSN.Instance().Events.On(Events.AdobeTarget.LOADED, function () {
            callback();
        });
    }
}

HSN.OnConfigLoaded = function (callback) {
    if (HSN.Config) {
        callback();
    } else {
        HSN.Instance().Events.On(Events.Config.LOADED, function () {
            callback();
        });
    }
}

HSN.GoogleApiJsClientLoaded = function () {
    HSN.Instance().Events.Trigger(HSN.Application.EVENT.ON_GOOGLE_API_JS_CLIENT_LOADED);
}

HSN.PrintElement = function(elem) {
    var newWindow = window.open('', 'PRINT', 'height=400,width=600');

    newWindow.document.write('<html><head><title>' + document.title  + '</title>');
    newWindow.document.write('</head><body >');
    newWindow.document.write('<h1>' + document.title  + '</h1>');
    newWindow.document.write(document.getElementById(elem).innerHTML);
    newWindow.document.write('</body></html>');

    newWindow.document.close(); // necessary for IE >= 10
    newWindow.focus(); // necessary for IE >= 10*/

    newWindow.print();
    newWindow.close();

    return true;
}

// Expose the HSN namespace into the global scope.
window.HSN = HSN;

// Polyfills
if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) { // .length of function is 2
        'use strict';        
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        value: function (value) {

            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);

            // Steps 3-5.
            var len = O.length >>> 0;

            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;

            // Step 8.
            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ?
                len : end >> 0;

            // Step 11.
            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            // Step 12.
            while (k < final) {
                O[k] = value;
                k++;
            }

            // Step 13.
            return O;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/HSN.js